import type { AppDef } from "../../shell/nav";
import { ConsentPage } from "./ConsentPage";
import { DevicesPage } from "./DevicesPage";
import { HistoryPage } from "./HistoryPage";
import { LocationsPage } from "./LocationsPage";
import { RetentionPage } from "./RetentionPage";
import { SettingsPage } from "./SettingsPage";
import { VisitDetailPage } from "./VisitDetailPage";
import { VisitsPage } from "./VisitsPage";

/**
 * 来客受付。第 3 段で管理画面(拠点・同意文・設定。reception:admin)、第 4 段で来訪(一覧・登録・詳細。
 * 見える範囲は API が決めるのでロールで絞らない)を足した。第 6 段で受付端末(reception:admin)を足した。
 * 第 7 段で履歴(CSV 書き出し。範囲は API が決めるのでロールで絞らない)と保有期間(reception:admin)を足し、
 * アプリを有効にした(「概要」の準備中を外し、入口を来訪にした)。
 * ルートは他アプリと同じく `RequireApp('reception')`(me.apps に reception があるか)で守られる。
 * host(reception:host)はロールの上下関係の外なので、判定には hasRole ではなく hasExactRole を使う。
 */
export const RECEPTION: AppDef = {
  key: "reception",
  name: "来客受付",
  defaultPath: "visits",
  groups: [
    {
      label: "受付",
      items: [
        { path: "visits", label: "来訪", phase: "RC1", component: VisitsPage, feature: "reception.core" },
        { path: "history", label: "履歴", phase: "RC1", component: HistoryPage, feature: "reception.core" },
      ],
    },
    {
      label: "管理",
      items: [
        { path: "admin/locations", label: "拠点", phase: "RC1", component: LocationsPage, role: "reception:admin", feature: "reception.core" },
        { path: "admin/consent", label: "同意文", phase: "RC1", component: ConsentPage, role: "reception:admin", feature: "reception.core" },
        { path: "admin/devices", label: "受付端末", phase: "RC1", component: DevicesPage, role: "reception:admin", feature: "reception.core" },
        { path: "admin/retention", label: "保有期間", phase: "RC1", component: RetentionPage, role: "reception:admin", feature: "reception.core" },
        { path: "admin/settings", label: "設定", phase: "RC1", component: SettingsPage, role: "reception:admin", feature: "reception.core" },
      ],
    },
  ],
  extraRoutes: [
    { path: "visits/:visitId", component: VisitDetailPage },
  ],
};
